import { IVideoPlayerProps } from '@/types/VideoPlayerProps';
import getPublicConfig from '@/utils/getPublicConfig';

const publicRuntimeConfig = getPublicConfig();

export function ViewMedicaVideoPlayer({
  className,
  title,
  width,
  height,
  videoId,
}: IVideoPlayerProps): JSX.Element {
  return (
    <iframe
      className={className}
      height={height}
      width={width}
      frameBorder="0"
      allowFullScreen
      referrerPolicy="unsafe-url"
      title={title}
      src={`https://viewmedica.com/vm/viewmedica/embed/?client=${publicRuntimeConfig.VIEW_MEDICA_CLIENT_ID}&lang=en&openthis=${videoId}`}
      id="viewmedica_vm"
    />
  );
}

ViewMedicaVideoPlayer.defaultProps = {
  className: '',
};
